import { Box, Card, Skeleton } from "@mui/material";

import { theme } from "@/src/theme/theme";

const AuctionItemSkeleton = () => {
  return (
    <Card
      sx={{
        width: 288,
        height: 670,
        display: "flex",
        flexDirection: "column"
      }}
      elevation={4}
    >
      <Skeleton variant="rectangular" height={216} width="100%" />
      <Box sx={{ p: 2 }}>
        <Skeleton
          variant="text"
          sx={{ fontSize: (theme) => theme.typography.h2.fontSize }}
          width="80%"
        />
        <Skeleton
          variant="text"
          sx={{ fontSize: (theme) => theme.typography.body1.fontSize }}
          width="60%"
        />
        <Skeleton
          variant="text"
          sx={{ fontSize: (theme) => theme.typography.body2.fontSize }}
          width="90%"
        />
      </Box>
      <Box sx={{ p: 2, mt: "auto" }}>
        <Box sx={{ borderTop: 1, borderColor: theme.palette.divider, pt: 1 }}>
          <Skeleton variant="text" width="60%" />
          <Skeleton variant="text" width="40%" />
        </Box>
        <Skeleton variant="rectangular" height={36} sx={{ mt: 1 }} />
      </Box>
      <Box
        sx={{
          backgroundColor: theme.palette.semantic.secondary.hover,
          p: 1,
          borderTop: 1,
          borderColor: theme.palette.divider,
          minHeight: "41px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <Skeleton variant="text" width="40%" />
      </Box>
    </Card>
  );
};

export default AuctionItemSkeleton;
